import BaseService from "../../../base/base_service";
import { IElasticEventData } from "../../../../../common/interfaces/structured-logging-service-interface";

export default class FirebaseElasticService extends BaseService{

  static CLASS = 'FirebaseElasticService';

  sendConnected(){
    this._sendElasticEvent('FIREBASE_CONNECTED');
  }

  sendFallbackStarted(label: string, forced: boolean = false){
    this._sendElasticEvent('FIREBASE_FALLBACK_STARTED', label, forced ? "Forced" : "Not Forced");
  }

  sendConnectionFailed(label: string, value: string){
    this._sendElasticEvent('FIREBASE_CONNECTION_FAILED', label, value);
  }

  sendSubscriptionError(label: string, value: string){
    this._sendElasticEvent('FIREBASE_SUBSCRIPTION_ERROR', label, value);
  }

  sendMessageUpdate(label: string, value: string){
    this._sendElasticEvent('FIREBASE_MESSAGE_UPDATE', label, value);
  }

  private _sendElasticEvent(action: string, label: string = null, value: string = null){
    const data: IElasticEventData = {
      CGPEventCategory: 'FIREBASE',
      CGPEventAction: action
    };
    if (label) data.CGPEventLabel = label;
    if (value) data.CGPEventValue = value;
    this.serviceFactory.structuredLoggingService().getLogger(data).info();
  }
}
